import { Component, Input } from '@angular/core';

@Component({
	standalone: false,
	selector: 'qe-banner',
	templateUrl: './banner.component.html',
	styleUrls: ['./banner.component.scss'],
})
export class BannerComponent {
	@Input() type?: 'info' | 'warning' | 'error';
}
